import isArray from 'lodash/isArray';
import isError from 'lodash/isError';
import isString from 'lodash/isString';
import map from 'lodash/map';
import merge from 'lodash/merge';
import reduce from 'lodash/reduce';

export * from './sentry';
export * from './immutabilityHelper';
export * from './segment';

/**
 * Extracts a key-value object of errors from a Pharmakon error response
 * @param  {Error}  clientError      axios client error
 * @return {Object}
 */
export function extractValidationErrors(clientError: any) {
  const extracted = clientError?.response?.data?.errors;
  const nonFieldTest = /non_field_errors?/;

  if (isArray(extracted)) {
    const mappedErrors = map(extracted, function (err) {
      let splitPointer = [];
      if (err.source?.pointer) {
        splitPointer = err.source.pointer.split('/');
      }
      const obj: { [key: string]: string } = {};
      let key = splitPointer.pop();
      key = key && !nonFieldTest.test(key) ? key : '_generic';

      obj[key] = err.detail || '[CLIENT] Error detail is missing';
      return obj;
    });

    return reduce(
      mappedErrors,
      function (sum, item) {
        return merge(sum, item);
      },
      {}
    );
  } else if (isString(extracted)) {
    return {
      _generic: extracted,
    };
  } else if (!extracted && isError(clientError)) {
    return {
      _generic: clientError.message,
    };
  } else {
    return {};
  }
}
